import { render, staticRenderFns } from "./AppHeaderProfile.vue?vue&type=template&id=012a8ed1&scoped=true&"
import script from "./AppHeaderProfile.vue?vue&type=script&lang=ts&"
export * from "./AppHeaderProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AppHeaderProfile.vue?vue&type=style&index=0&id=012a8ed1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012a8ed1",
  null
  
)

export default component.exports